import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SharedStore } from '@shared/store/shared.signal-store';
import { environment } from 'environments/environment';
import { map } from 'rxjs';
import { whenCurrentUserLoaded } from './current-user-loaded';

export type AccountView = 'dashboard' | 'strategies';

/**
 * Each account type has exactly one view: a strategy subaccount gets the embedded strategy UI and
 * every other account gets the OTC UI. There is no navigation between the two, so this is the
 * only view the active account can be in.
 */
export const accountHomeUrl = (isStrategyAccountActive: boolean): string =>
  environment.coinlionEnabled && isStrategyAccountActive ? '/strategies' : '/dashboard';

/**
 * Keeps a view closed to the accounts that do not own it, so neither one can be reached by typing
 * the URL; the user is sent to the view their active account does own.
 */
export const accountViewGuard =
  (view: AccountView): CanActivateFn =>
  () => {
    const sharedStore = inject(SharedStore);
    const router = inject(Router);

    return whenCurrentUserLoaded().pipe(
      map(() => {
        const home = accountHomeUrl(sharedStore.isStrategyAccountActive());

        return home === `/${view}` || router.parseUrl(home);
      }),
    );
  };
